<template>
  <div @change="send" class="quickpick">
    <input ref="input" :list="_uid" v-model="inputState"><select :value="value" tabindex="-1"><option v-for="item in list">{{item}}</option></select>
    <div class="quicklist">
      <label v-for="item in quicklist" :key="item">{{item}}<input type="radio" :name="_uid+'quick'" :value="item"></label>
    </div>
    
    <datalist :id="_uid"><option v-for="item in list">{{item}}</option></datalist>
  </div>
</template>

<script>
export default {
  name: 'quickPick',
  data () {
    return {
      inputState:''
    }
  },
  watch: {
    value(v){
      this.inputState=v
    }
  },
  created(){
    this.$on('focus',function(v){
      this.$refs.input.focus();
    });
  },
  props:['value','list','quicklist'],
  methods:{
    send(e){
      this.$emit('input',e.target.value)
    }
  }  
}
</script>

<style>
.quicklist{
  overflow:auto;
}
.quicklist>label>input{
  display:none;
}
.quicklist>label{
  font-weight:bold;
  display:block;
}
.quickpick>select{
  width:23px;
}
</style>


// WEBPACK FOOTER //
// quick-pick.vue?748da4b3